export default "/images/pwd-icon.svg?b42c232dad1fa1b02f796f2bc3e18172";